import styled from "styled-components";

import * as MachineDetailsS from "_/components/machine-details/styled";

export const ChartWidget = MachineDetailsS.TemperatureWidget;

export const MachineTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
  overflow-x: auto;
`;

export const Wrapper = styled.div`
  height: calc(100vh - 500px);
  background-color: ${(p) => p.theme.color.palette.oilBlack};
  position: relative;
`;

export const TooltipContent = styled.div`
  background: ${(p) => p.theme.color.palette.satinBlack};
  border: 1px solid ${(p) => p.theme.color.palette.graniteBlack};
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  color: ${(p) => p.theme.text.default};
  user-select: none;
`;

export const TooltipRow = styled.div<{ $color: string }>`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(p) => p.$color};
    flex-shrink: 0;
  }
`;

export const TooltipTime = styled.div`
  margin-bottom: 0.25rem;
  color: ${(p) => p.theme.color.palette.spanishGrey};
`;

export const TooltipSetpoint = styled.span`
  color: ${(p) => p.theme.color.palette.spanishGrey};
  min-width: 3.5em;
  text-align: right;
`;

export const TooltipValue = styled.span`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
`;
